import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React, { useRef, useCallback } from 'react';
import { PropTypes } from '@panneau/core';
import { useDocumentEvent } from '@panneau/core/hooks';
import Button from '@panneau/element-button';
import Label from '@panneau/element-label';
import Link from '@panneau/element-link';

var styles = {"container":"panneau-element-dropdown-container"};

var _excluded = ["id", "type", "className", "label", "children", "onClick", "active"];
var propTypes = {
  items: PropTypes.menuItems,
  children: PropTypes$1.node,
  visible: PropTypes$1.bool,
  align: PropTypes.dropdownAlign,
  className: PropTypes$1.string,
  itemClassName: PropTypes$1.string,
  onClickItem: PropTypes$1.func,
  onClickOutside: PropTypes$1.func
};
var defaultProps = {
  items: [],
  children: null,
  visible: false,
  align: null,
  className: null,
  itemClassName: null,
  onClickItem: null,
  onClickOutside: null
};
var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
    children = _ref.children,
    visible = _ref.visible,
    align = _ref.align,
    className = _ref.className,
    itemClassName = _ref.itemClassName,
    onClickItem = _ref.onClickItem,
    onClickOutside = _ref.onClickOutside;
  var refContainer = useRef(null);
  var onDocumentClick = useCallback(function (e) {
    if (refContainer.current !== null && !refContainer.current.contains(e.target) && visible && onClickOutside !== null) {
      onClickOutside(e);
    }
  }, [visible, onClickOutside]);
  useDocumentEvent('click', onDocumentClick, visible);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, 'dropdown-menu', 'relative', _defineProperty(_defineProperty(_defineProperty({}, "dropdown-menu-".concat(align), align !== null), "show", visible), className, className !== null)]),
    ref: refContainer,
    style: {
      right: align === 'end' ? 0 : 'auto',
      left: align === 'start' ? 0 : 'auto'
    }
  }, children !== null ? children : items.map(function (it, index) {
    var _it$id = it.id,
      id = _it$id === void 0 ? null : _it$id,
      _it$type = it.type,
      type = _it$type === void 0 ? 'link' : _it$type,
      _it$className = it.className,
      customClassName = _it$className === void 0 ? null : _it$className,
      _it$label = it.label,
      label = _it$label === void 0 ? null : _it$label,
      _it$children = it.children,
      itemChildren = _it$children === void 0 ? null : _it$children,
      _it$onClick = it.onClick,
      customOnClick = _it$onClick === void 0 ? null : _it$onClick,
      _it$active = it.active,
      active = _it$active === void 0 ? false : _it$active,
      itemProps = _objectWithoutProperties(it, _excluded);
    var ItemComponent = 'div';
    if (type === 'link') {
      ItemComponent = Link;
    } else if (type === 'header') {
      ItemComponent = 'h6';
    } else if (type === 'button') {
      ItemComponent = Button;
    }
    var finalOnClickItem = customOnClick !== null || type === 'link' && onClickItem !== null ? function (e) {
      if (customOnClick !== null) {
        customOnClick(e);
      }
      if (type === 'link' && onClickItem !== null) {
        onClickItem(e);
      }
    } : null;
    return ItemComponent !== null ? /*#__PURE__*/React.createElement(ItemComponent, Object.assign({
      key: "item-".concat(id || index),
      className: classNames(_defineProperty(_defineProperty({
        'dropdown-item': type === 'link',
        'dropdown-divider': type === 'divider',
        'dropdown-header': type === 'header',
        'text-start': true,
        'd-block': true,
        'w-100': true,
        active: active
      }, itemClassName, itemClassName !== null), customClassName, customClassName !== null)),
      onClick: finalOnClickItem
    }, itemProps || null), label !== null ? /*#__PURE__*/React.createElement(Label, null, label) : itemChildren) : null;
  }));
};
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

export { Dropdown as default };
